import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/blocks/images/NextImageV2.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/entities/common/components/SearchInput.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/library/entities/core/market/components/MarketList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/entities/market/instrument/components/InstrumentFollowButton.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
